"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createStyles_1 = require("@material-ui/styles/createStyles");
exports.default = (function (theme) {
    var navLinkContainer = {
        height: '100%',
        marginLeft: 14,
        display: 'flex',
        alignItems: 'center',
        zIndex: 50,
    };
    var navLinkText = {
        textTransform: 'uppercase',
        letterSpacing: 1,
        fontSize: 15,
        textDecoration: 'none !important',
        color: theme.palette.grey[500]
    };
    var headerHeight = 58;
    return createStyles_1.default({
        headerContainer: {
            backgroundColor: '#f5f5f5',
            width: '100%',
            position: 'fixed',
            height: headerHeight,
            justifyContent: 'center',
            flexDirection: 'row',
            zIndex: 40
        },
        headerContentWrapper: {
            justifyContent: 'space-between',
            maxWidth: 1378 + 32,
            padding: '0 16px',
            width: '100%'
        },
        leftRightContainers: {
            width: 'auto',
            height: '100%',
            alignItems: 'center'
        },
        navLinkContainer: navLinkContainer,
        navLinkText: navLinkText,
        currentNavLinkContainer: Object.assign({}, navLinkContainer, {
            borderBottom: "4px solid " + theme.palette.primary.main,
        }),
        currentNavLinkText: Object.assign({}, navLinkText, {
            color: theme.palette.primary.main,
            marginBottom: -4
        }),
        currentUserMenuButton: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            cursor: 'pointer',
        },
        currentUserMenu: {
            padding: '8px 0',
            borderRadius: 0,
            boxShadow: 'none'
        },
        currentUserMenuLink: {
            'padding': '14px 24px 14px 24px',
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
                color: 'unset',
                textDecoration: 'none'
            }
        },
        subheader: {
            position: 'fixed',
            height: 106,
            left: 0,
            top: headerHeight,
            paddingTop: 32,
            backgroundImage: 'linear-gradient(90deg, #D9DAEB, #EBE5E3)',
            zIndex: 10
        },
        subheaderContainer: {
            padding: '0 16px',
            maxWidth: 1378 + 32
        }
    });
});
